module.exports = __webpack_public_path__ + "img/UC-Javascript_understanding_the_weird.4f7e2788.jpg";